import { cn } from 'cn';

export interface InputGroupProps {
  children: React.ReactNode;
  className?: string;
}

const InputGroup = ({ children, className, ...props }: InputGroupProps) => {
  return (
    <div
      {...props}
      className={cn(
        'relative flex flex-col justify-center kunde:gap-y-3',
        className,
      )}
    >
      {children}
    </div>
  );
};

export default InputGroup;
